import React, { FC, useCallback, MouseEventHandler } from 'react';

import { Button, ButtonProps } from '@lglp/components';
import { useDispatch } from 'react-redux';

import {
  setForceDisplay,
  setOpened,
  setVisible,
} from '../../../../actions/rgpd';

export const RGPDButton: FC<RGPDButtonProps> = ({
  className,
  onClick,
  children,
  ...rest
}) => {
  const dispatch = useDispatch();

  const clickHandler: MouseEventHandler = useCallback(
    (event) => {
      dispatch(setOpened(false));
      dispatch(setVisible(true));
      dispatch(setForceDisplay(true));

      if (onClick) {
        onClick(event);
      }
    },
    [dispatch, onClick]
  );

  return (
    <Button className={className} onClick={clickHandler} {...rest}>
      {children}
    </Button>
  );
};

export type RGPDButtonProps = ButtonProps;
